import { render } from "./scoreDistributionTab.vue?vue&type=template&id=80335b0a&scoped=true"
import script from "./scoreDistributionTab.vue?vue&type=script&lang=js"
export * from "./scoreDistributionTab.vue?vue&type=script&lang=js"

import "./scoreDistributionTab.vue?vue&type=style&index=0&id=80335b0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80335b0a"]])

export default __exports__